import React from "react";
import {Navigate} from "react-router-dom";
import useAuthCheck from "../../hooks/use-auth-check";

const HomePage: React.FC = () => {
    const { isAuthenticated, isFetchingAuthenticationInformations } = useAuthCheck();

    if (isFetchingAuthenticationInformations) {
        return null;
    }

    return isAuthenticated ?
        <Navigate to="/projects" replace /> :
        <Navigate to="/sign-in" replace />;
};

export default HomePage;
